import Lottie from "lottie-react";
import emptyCartAnimation from "../assets/lottie/empty.json";

export const EmptyState = ({ message }) => {
    return (
        <div className="flex flex-col items-center justify-center p-12 text-center">
            <Lottie
                animationData={emptyCartAnimation}
                loop={true}
                className="w-64 h-64 mb-6 opacity-80"
            />
            {message && <h3 className="text-20 font-bold text-gray-500">{message}</h3>}
        </div>
    );
};
